import { render, staticRenderFns } from "./schedule-form.vue?vue&type=template&id=04652be1&"
import script from "./schedule-form.vue?vue&type=script&lang=js&"
export * from "./schedule-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports